module.exports = __webpack_public_path__ + "img/banner2.1599d461.png";